
import React from 'react';
import GasAlarmsTable from './GasAlarmsTable';
import { recentAlarms } from '@/data/gas-analytics-data';

interface GasAlarmsTabProps {
  onDeviceClick?: (device: typeof recentAlarms[0]) => void;
}

const GasAlarmsTab = ({ onDeviceClick }: GasAlarmsTabProps) => {
  return (
    <div className="space-y-6">
      <GasAlarmsTable onDeviceClick={onDeviceClick} />
    </div>
  );
};

export default GasAlarmsTab;
